import React from 'react';

import { TitleWithDescription } from '@infoods/lifebase-ui';

import classes from './HeaderRow.module.scss';
import {
  GridStickyGroup,
  GridTableCell,
  GridTableRow,
} from '../../../../../shared/components/table-components';

const HeaderRow = () => {
  const titleGeneralProps = { titleFont: 'inherit', withoutGap: true } as const;

  return (
    <GridTableRow variant="unstyled" className={classes.header}>
      <GridStickyGroup>
        <GridTableCell>Name</GridTableCell>
      </GridStickyGroup>
      <GridTableCell>Subscription</GridTableCell>
      <GridTableCell>
        <TitleWithDescription
          {...titleGeneralProps}
          title="Total Amount"
          description="sales tax incl"
        />
      </GridTableCell>
      <GridTableCell>Status</GridTableCell>
      <GridTableCell>SWYMO Fees</GridTableCell>
      <GridTableCell>Stripe Fees</GridTableCell>
      <GridTableCell>
        <TitleWithDescription
          {...titleGeneralProps}
          title="Entity Deposit"
          description="sales tax incl"
        />
      </GridTableCell>
      <GridTableCell>Sales Tax</GridTableCell>
      <GridTableCell>SaaS Tax</GridTableCell>

      <GridTableCell>
        <TitleWithDescription
          {...titleGeneralProps}
          title="Entity NET"
          description="no taxes"
        />
      </GridTableCell>
      <GridTableCell>Payment Date</GridTableCell>
      <GridTableCell justify="center">Invoice</GridTableCell>
    </GridTableRow>
  );
};

export { HeaderRow };
